<template>
    <div class="auth">
        <div class="auth-title">{{ $t('auth.login') }}</div>
        <div class="auth-body">
            <hybrid-auth v-if="hybridAuth" type="sign_in"/>
            <div v-if="hybridAuth" class="auth-separator">
                <span>{{ $t('or') }}</span>
            </div>
            <div class="auth-login">
                <b-form @submit.prevent="onSubmit">
                    <div class="form-group">
                        <b-form-input id="form-field-email" v-model="form.email" type="email"
                                      :placeholder="$t('email')"
                                      :state="validation.email.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.email.valid">
                            {{ validation.email.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group">
                        <div class="password-wrap">
                        <b-form-input id="form-field-password" v-model="form.password" :type="passwordType"
                                      :placeholder="$t('auth.password')"
                                      :state="validation.password.valid"
                                      required></b-form-input>
                            <a href="#" @click.prevent="switchPasswordType" class="password-icon">
                                <span class="material-icon icon-remove_red_eye"/>
                            </a>
                        </div>
                        <b-form-invalid-feedback :state="validation.password.valid">
                            {{ validation.password.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <!--<div class="form-group">
                        <b-form-checkbox v-model="remember">{{ $t('auth.remember') }}</b-form-checkbox>
                    </div>-->
                    <div class="d-flex">
                        <router-link v-if="!hideForgotPasswordLink"
                                     :to="i18nLink('forgot-password')"
                                     class="btn btn-link mr-2 text-dark text-uppercase">
                            {{ $t('auth.forgot_password') }}
                        </router-link>
                        <button type="submit" class="btn btn-primary btn-shadow ml-auto text-uppercase">
                            {{ $t('auth.login') }}
                        </button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
  import HybridAuth from './HybridAuth';
  import login from 'src/mixins/loginComponent';

  export default {
    mixins: [login],
    components: {
      HybridAuth,
    },
  };
</script>
